import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { Switch, Route, HashRouter } from 'react-router-dom';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import { getQueryString } from '@/utils/util';
import './mock';
import { getDistributionAllApi } from '@/services/user';
const store = createStore(rootReducer);

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'en-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;

      case 'en-US':
        return enUS;

      default:
        return zhCN;
    }
  }

  useEffect(() => {
    const search = decodeURIComponent(window.location.href);
    const href = search.split('?');
    let hrefToken = '';
    let hrefUserInfo = '';

    if (href.length > 1) {
      hrefToken = getQueryString(href[1], 'token');
      hrefUserInfo = getQueryString(href[1], 'userInfo');

      if (!hrefToken) {
        hrefToken = localStorage.getItem('token');
        hrefUserInfo = localStorage.getItem('userInfo');
      }
    } else {
      hrefToken = localStorage.getItem('token');
      hrefUserInfo = localStorage.getItem('userInfo');
    }

    if (hrefToken) {
      localStorage.setItem('token', hrefToken);
      getDistributionAll();
    } else {// window.location.href = 'https://manage.qnvipmall.com/#/dashboard';
    }

    if (hrefUserInfo) {
      store.dispatch({
        type: 'update-userInfo',
        payload: {
          userInfo: JSON.parse(hrefUserInfo || '{}'),
          userLoading: false
        }
      });
      localStorage.setItem('userInfo', hrefUserInfo);
    }
  }, []);

  const getDistributionAll = () => {
    getDistributionAllApi({
      pageSize: 1000
    }).then(res => {
      const list = [];

      if (res && res.length) {
        res.forEach(item => {
          if (item.childList && item.childList.length) {
            item.childList.forEach(el => {
              if (el.childList && el.childList.length) {
                el.childList.forEach(cl => {
                  list.push(cl);
                });
              }
            });
          }
        });
      }

      store.dispatch({
        type: 'update-distributionList',
        payload: {
          distributionList: list
        }
      });
    });
  };

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(HashRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}

ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));